import { t as tDefault } from 'i18next';

export const t = (str: string | string[]) => tDefault(str);
